import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the WastePickupFormDetailScreen state domain
 */

const selectWastePickupFormDetailScreenDomain = state =>
  state.wastePickupFormDetailScreen || initialState;

/**
 * Other specific selectors
 */

/**
 * Default selector used by WastePickupFormDetailScreen
 */

const makeSelectWastePickupFormDetailScreen = () =>
  createSelector(
    selectWastePickupFormDetailScreenDomain,
    substate => substate,
  );

export default makeSelectWastePickupFormDetailScreen;
export { selectWastePickupFormDetailScreenDomain };
